import type {
  RoundCommandEvent,
  RoundSnapshot,
} from "../../domain/round/round-reducer.js";
import type { RoundSyncApi } from "../sync/round-sync-engine.js";

export const roundSyncApi: RoundSyncApi = {
  async sync(events: RoundCommandEvent[]) {
    const response = await fetch("/api/v1/round-events/sync", {
      method: "POST",
      credentials: "include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ events }),
    });
    if (!response.ok) {
      const problem = (await response.json().catch(() => null)) as {
        detail?: string;
      } | null;
      throw new Error(problem?.detail ?? "The round could not sync.");
    }
    return response.json() as ReturnType<RoundSyncApi["sync"]>;
  },
};

export async function loadRoundSnapshot(
  roundId: string,
): Promise<RoundSnapshot> {
  const response = await fetch(`/api/v1/rounds/${roundId}`, {
    credentials: "include",
  });
  const body = (await response.json().catch(() => null)) as {
    snapshot?: RoundSnapshot;
    detail?: string;
  } | null;
  if (!response.ok || !body?.snapshot) {
    throw new Error(body?.detail ?? "The live score could not refresh.");
  }
  return body.snapshot;
}

export async function resolveRoundConflict(
  conflictId: string,
  resolution: "keep-server" | "use-local",
): Promise<RoundSnapshot> {
  const response = await fetch(
    `/api/v1/round-conflicts/${conflictId}/resolve`,
    {
      method: "POST",
      credentials: "include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ resolution }),
    },
  );
  const body = (await response.json().catch(() => null)) as {
    snapshot?: RoundSnapshot;
    detail?: string;
  } | null;
  if (!response.ok || !body?.snapshot) {
    throw new Error(
      body?.detail ?? "The score conflict could not be resolved.",
    );
  }
  return body.snapshot;
}
